import { css } from '@planne-software/uni/mui/material';
import { uni, type UniTypographyVariant, type UniTypographyWeight } from '@planne-software/uni/v2';

/**
 * UNI v2 typography as a css block for Uni/MUI `styled` — interpolate it into a
 * styled component, like the legacy helpers in ./Typography.ts (`${Heading6}` etc.),
 * but sourced from the UNI v2 tokens.
 *
 * Covers font-family (display vs text), font-size, font-weight, line-height,
 * font-style and font-feature-settings. font-size/line-height reference the
 * responsive `--uni-*` vars, so the style stays responsive. Color is NOT
 * included — set it per usage with `uni('fg-...')`.
 *
 * @example
 * import { styled } from '@planne-software/uni/mui/material';
 * import { uni } from '@planne-software/uni/v2';
 * import { uniTypography } from '@src/fonts/typography/uniTypography';
 *
 * const Heading = styled('h2')`
 *   ${uniTypography('text-lg', 'semibold')}
 *   color: ${uni('fg-neutral-static-default-heading')};
 * `;
 */
export const uniTypography = (variant: UniTypographyVariant, weight: UniTypographyWeight = 'regular') => {
  const family: 'display' | 'text' = variant.startsWith('display') ? 'display' : 'text';
  return css`
    font-family: ${uni(`font-family-${family}`)};
    font-size: ${uni(`typography-font-size-${variant}`)};
    font-weight: ${uni(`typography-font-weight-${weight}`)};
    line-height: ${uni(`typography-line-height-${variant}`)};
    font-style: normal;
    font-feature-settings: 'ss01' on;
  `;
};
